import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Col } from "reactstrap";
import ReactTableBase from "../../../../shared/components/table/ReactTableBase";

const RadiopharmacyDataReactTable = ({
  title,
  reactTableData,
}) => {
  const isResizable = false;
  const isSortable = false;
  const withDragAndDrop = false;
  const withPagination = true;
  const withSearchEngine = false;


  const tableConfig = {
    isResizable,
    isSortable,
    withDragAndDrop,
    withPagination,
    withSearchEngine,
    manualPageSize: [5, 10, 15, 20, 25],
    placeholder: "Buscar",
  };

  return (
    <Col md={12} lg={12}>
      <div className="react-table__wrapper">
        <div className="card__title">
          <h5 className="bold-text">{title}</h5>
        </div>
      </div>
      <ReactTableBase
        key={
          withSearchEngine || isResizable  ? "modified" : "common"
        }
        columns={reactTableData.tableHeaderData}
        data={reactTableData.tableRowsData}
        tableConfig={tableConfig}
      />
    </Col>
  );
};

RadiopharmacyDataReactTable.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        name: PropTypes.string,
      })
    ),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default RadiopharmacyDataReactTable;

